export default "__VITE_ASSET__Dcc3l7dr__"